import OrganizationArrivalRatesPerHour from "../../../components/organization/reports/daily/OrganizationArrivalRatesPerHour";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationArrivalRatesPerHour = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_arrival_rates_per_hour}
    title="Arrival Rates Per Hour"
    helmetTitle="Daily Organization Arrival Rates Per Hour"
    descriptionKey="ArrivalRatesPerHour"
    columnDefinitions={ARRIVAL_RATES_SUMMARY_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationArrivalRatesPerHour
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationArrivalRatesPerHour;
